import React from "react";
import {Button, Row, Col, Glyphicon, FormControl} from "react-bootstrap";
import AscComponent from "../../components/AscComponent";
import CommonTable from "../../containers/Elements/Table/CommonTable";
import AscAudio from "../../containers/Elements/Audio/Audio";
import VoiceFileModal from "./VoiceModal";
import AscConfirm from "../../components/Modal/AscConfirm";
import moment from 'moment';
import * as GlobalConst from "../../components/AscConstants";

export default class VoiceFile extends AscComponent {
    constructor(props) {
        super(props);
        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            filtered: [],
            pages: null,
            loading: false,

            // modal item
            show: false,
            modalType: null,

            // 追加確認ポップアップ表示のON/OFF
            isSetShowAddingConfirmationPopup: false,
            showConfirm: false,
            confirmMemo: "",
            confirmValue: "",

            // select item
            companySelect: [],

            // data item
            voiceId: "",
            companyId: "",
            companyName: "",
            audioName: "",
            audioType: "",
            audioFile: [],
            audioURL: "",
            audioStream: [],
            audioSec: 0,
            memo: "",
            // button_disabled
            buttondisabledArr: {
                "company_id" : []
            },
        };

        
    }

    componentDidMount = async() => {
        // 追加確認ポップアップ表示の対象画面であるか
        try{
            const result = await this.ascAxios("post", `Common/getShowAddingConfirmationPopupTargetPage`);
            this.isTargetShowAddingConfirmationPopup = result.data.includes(this.reactContainerPath.split("/").pop());
        }catch(err){
            console.log(err);
            this.isTargetShowAddingConfirmationPopup = false;
        }


    }

    getColumnsData() {
        let returnArr = [];

        returnArr.push({
            Header: this.props.langText.Body.Id,
            accessor: "id",
            filterable: false,
            width: this.props.boardWidth.id,
        });

        // oem以上は会社カラム表示
        if (this.getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem)) {
            returnArr.push({
                Header: this.props.langText.Body.CompanyName,
                accessor: "cm12_companies.company_name",
                Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "cm12_companies.company_name")} />
            });
        }

        returnArr.push({
            Header: this.props.langText.Body.AudioName,
            accessor: "voice_name",
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "voice_name")} />
        });

        returnArr.push({
            Header: this.props.langText.Body.Memo,
            accessor: "memo",
            Filter: () => <FormControl onChange={e => this.onFilterChange(e.target.value, "memo")} />
        });

        returnArr.push({
            Header: this.props.langText.Body.Control,
            filterable: false,
            sortable: false,
            accessor: "voice_file_url",
            width: this.props.boardWidth.XLargeControl,
            Cell: data => {
                let rowData = [];
                if (this.props.currentPermission.playback) {
                    rowData.push(
                        <AscAudio
                            key = {0}
                            type = "url"
                            title = {data.row.voice_name}
                            data = {data.value}
                            className = "control-button"/>
                    );
                }
                if (this.props.currentPermission.export) {
                    rowData.push(
                        <Button
                            key={2}
                            bsSize="xsmall"
                            onClick={this.downloadData(data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="download-alt"/>
                        </Button>
                    );
                }

                if (this.props.currentPermission.edit) {
                    rowData.push(
                        <Button
                            key={3}
                            bsSize="xsmall"
                            onClick={this.modalShow('update', data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="pencil"/>
                        </Button>
                    );
                } else {
                    rowData.push(
                        <Button
                            key={3}
                            bsSize="xsmall"
                            onClick={this.modalShow('read', data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="eye-open"/>
                        </Button>
                    );
                }

                if (this.props.currentPermission.delete) {
                    rowData.push(
                        <Button
                            key={4}
                            bsSize="xsmall"
                            onClick={this.modalShow('delete', data.row._original)}
                            className="control-button"
                        >
                            <Glyphicon glyph="minus"/>
                        </Button>
                    );
                }

                return (
                    <Row className="text-center">
                        {rowData}
                    </Row>
                );
            }
        });

        return returnArr;
    }

    // 共通処理
    common_buttondisabledLengthCheck = (param,switchdata) => {
        switch (switchdata)
        {
            case `push`:
                if(this.state.buttondisabledArr[param].length === 0)
                {
                    this.state.buttondisabledArr[param].push("dataset");
                }
            break;
            case `pop`:
                this.state.buttondisabledArr[param].pop();
            break;
            default:
                console.log("common_buttondisabledLengthCheck_switchErr");
            break;
        }
    }

    downloadData = (param) => event => {
        this.ascAxios('get', this.baseURL + `/Download/s3SoundDownload/${encodeURIComponent(param.voice_file_url)}`)
        .then(res => {
            const downLoadLink = document.createElement("a");
            downLoadLink.href = res.data;
            downLoadLink.click();
            downLoadLink.remove();

            // アクセスログ保存
            this.saveAccessLogs({
                "resource" : `/VoiceFile/voiceLogDownload`, 
                "body" : {
                    "voice_file_url" : param.voice_file_url,
                    "voice_name" : param.voice_name,
                    "company_name" : param.cm12_companies ? param.cm12_companies.company_name : "",
                    "memo" : param.memo || "",
                    "voice_id" : param.id
                }
            });
        })
        //失敗の場合
        .catch(err => {
            alert(this.getErrorString({code:44}));
        })
    };

    modalShow = (modalType, param) => async event => {
        event.preventDefault();

        let setData = {
            voiceId: param && param.id
                ? param.id
                : "",
            companyId: param && param.cm12_companies && param.cm12_companies.id
                ? param.cm12_companies.id
                : "",
            companyName: param && param.cm12_companies && param.cm12_companies.company_name
                ? param.cm12_companies.company_name
                : "",
            audioName: param && param.voice_name
                ? param && param.voice_name
                : "",
            audioType: param && param.voice_type
                ? param.voice_type
                : "fileUpload",
            audioURL: param && param.voice_file_url
                ? param.voice_file_url
                : "",
            audioSec: param && param.audioSec
                ? param.audioSec
                : 0,
            memo: param && param.memo
                ? param.memo
                : "",
            audioFile: [],
            audioStream: [],
            voiceUsingData: [],
            voiceValidationFlag: true,
            modalType,
            show: true
        };

        //使用中の音声かを確認して、使用中の場合音声削除不可バリデーション追加・使用している箇所表示
        if(modalType == "delete"){
            try {
                let checkVoiceUsing = await this.ascAxios('post', `${this.reactContainerPath}/checkVoiceUsing`, {voice_id : param.id});
                let checkVoiceUsingData = checkVoiceUsing.data;
                let checkVoiceUsingNull = checkVoiceUsingData.every(element => element.length === 0);
                if(!checkVoiceUsingNull){
                    setData.voiceValidationFlag = false;
                    setData.voiceUsingData = [];
                    if(checkVoiceUsingData[0]){
                        checkVoiceUsingData[0].forEach(element => {
                            setData.voiceUsingData.push(
                                element.memo 
                                ? this.sprintf(
                                    this.props.langText.Message.AudioDeleteError_External,
                                    element.memo + " (" + element.display_number + ")")
                                : this.sprintf(
                                    this.props.langText.Message.AudioDeleteError_External,
                                    element.display_number)
                            );
                        });
                    }
                    if(checkVoiceUsingData[1]){
                        checkVoiceUsingData[1].forEach(element => {
                            setData.voiceUsingData.push(
                                this.sprintf(
                                    this.props.langText.Message.AudioDeleteError_Business,
                                    element.cm31_business_calendar_infos.business_calendar_name
                                )
                            );
                        });
                    }
                    if(checkVoiceUsingData[2]){
                        checkVoiceUsingData[2].forEach(element => {
                            setData.voiceUsingData.push(
                                this.sprintf(
                                    this.props.langText.Message.AudioDeleteError_Irregular,
                                    element.cm31_business_calendar_infos.business_calendar_name
                                )
                            );
                        });
                    }
                    if(checkVoiceUsingData[3]){
                        checkVoiceUsingData[3].forEach(element => {
                            setData.voiceUsingData.push(
                                this.sprintf(
                                    this.props.langText.Message.AudioDeleteError_Script,
                                    element.cm71_script_versions.cm70_scripts.name
                                )
                            );
                        });
                    }
                    if(checkVoiceUsingData[4]){
                        checkVoiceUsingData[4].forEach(element => {
                            setData.voiceUsingData.push(
                                this.sprintf(
                                    this.props.langText.Message.AudioDeleteError_Predictive,
                                    element.task_name
                                )
                            );
                        });
                    }

                    setData.voiceUsingData = setData.voiceUsingData.map(elem =>{
                        return <div>{elem}</div>
                    });
                }
            } catch (err) {
                console.error(err)
                this.showErrorObjectMesssage(err, "GetDataError");
            }
        }

        // 新規作成時にcompany以下なら会社固定
        if (!param && this.getScopeLessThanEqual(GlobalConst.SCOPE_OBJECT.company)) {
            setData.companyId = this.props.userInfo.company_id
            setData.companyName = this.props.userInfo.company_name
        }

        // 追加確認ポップアップ表示設定
        setData.isSetShowAddingConfirmationPopup =
            setData.companyId !== ""
                ? await this.getIsShowAddingConfirmationPopup(setData.companyId)
                : false
            ;

        this.setState(setData);
        this.getCompanySelect();
    };

    audioDownload = (name, url) => event => {
        let myA = document.createElement("A");
        myA.download = name;
        myA.href = url;
        myA.click();
    };

    onFileChange(event, param) {
        let $this = this;
        if (param === "audioFile" && event.target.files[0]) {
            super.onFileChange(event, param);
            if (!event.target.value) {
                return;
            }
            let audioElem = document.createElement("AUDIO");
            audioElem.preload = "metadata";
            audioElem.src = URL.createObjectURL(event.target.files[0]);

            audioElem.onloadedmetadata = function () {
                $this.setState({
                    audioSec: Math.round(audioElem.duration)
                })
            }
        }
    }

    onClickHandle = modalType => event => {
        let {
            voiceId,
            companyId,
            audioName,
            audioType,
            audioFile,
            audioURL,
            audioStream,
            audioSec,
            memo,
            voiceValidationFlag,
            isSetShowAddingConfirmationPopup,
            confirmMemo
        } = this.state;

        // 追加確認ポップアップ表示判定
        if (this.isTargetShowAddingConfirmationPopup && 
            isSetShowAddingConfirmationPopup
        ) {
            if (!this.state.showConfirm) {
                // 初回：追加確認ポップアップを表示（確認欄を初期化）
                // 追加確認ポップアップを表示
                this.onClickConfirm(event, true);
                return;
            }
        } else {
            // 追加確認ポップアップ表示設定がOFFである場合、
            // 通常の確認ポップアップを表示
            if (!window.confirm(`${this.createPopupMessage(
                this.props.langText.Body.AudioName,
                audioName,
                modalType
            )}`)) {
                return;
            }
        }

        // 追加確認ポップアップからの実行、または通常の確認ポップアップOK後の処理

        let myForm = document.createElement("FORM");
        myForm.enctype = "multipart/form-data";

        let uploadForm = new FormData(myForm);
        uploadForm.append("voiceId", voiceId);
        uploadForm.append("companyId", companyId);
        uploadForm.append("audioName", audioName);
        uploadForm.append("audioType", audioType);
        uploadForm.append("files", audioFile[0]);
        uploadForm.append("audioSec", audioSec);
        uploadForm.append("audioURL", audioURL);
        uploadForm.append("memo", memo);
        uploadForm.append("voiceValidationFlag",voiceValidationFlag);

        // 追加確認ポップアップからの実行の場合、確認メモも送信
        uploadForm.append("confirmMemo", confirmMemo);
        uploadForm.append("isSetShowAddingConfirmationPopup", isSetShowAddingConfirmationPopup);

        switch (modalType) {
            case "insert":
                this.blockUI();
                this.ascAxios('post', `${this.reactContainerPath}/insert`, uploadForm)
                    .then(result => {
                        alert(this.props.langText.Message.DataInsertSuccess);
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: ""
                        });
                    }).catch(err => {
                        alert(this.getErrorString(err.response.data));
                        if (err.response.data.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: ""
                            });
                        }
                    });
                break;

            case "update":
                this.blockUI();
                this.ascAxios('post', `${this.reactContainerPath}/update`, uploadForm)
                    .then(result => {
                        alert(this.props.langText.Message.DataUpdateSuccess);
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: ""
                        });
                    }).catch(err => {
                        alert(this.getErrorString(err.response.data));
                        if (err.response.data.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: ""
                            });
                        }
                    });
                break;

            case "delete":
                this.blockUI();
                this.ascAxios('post', `${this.reactContainerPath}/delete`, uploadForm)
                    .then(result => {
                        alert(this.props.langText.Message.DataDeleteSuccess);
                        this.reactTableRefresh();
                        this.setState({
                            show: false,
                            showConfirm: false,
                            confirmMemo: ""
                        });
                    }).catch(err => {
                        alert(this.getErrorString(err.response.data));
                        if (err.response.data.code === "SendMailWhenDataChangedError") {
                            this.reactTableRefresh();
                            this.setState({
                                show: false,
                                showConfirm: false,
                                confirmMemo: ""
                            });
                        }
                    });
                break;

            default:
                alert(this.getErrorString({code: 'modal'}));
                this.setState({
                    show: false,
                    showConfirm: false,
                    confirmMemo: ""
                });
                break;
        }
    };





    onSelectChange = async (event, param) => {
        // 基底クラスのonSelectChangeを呼び出し
        super.onSelectChange(event, param);
        
        // 会社選択時に追加確認ポップアップ設定を再取得
        if (param === "companyId") {
            const companyId = (event && event.value) ? event.value : "";
            if (companyId) {
                try {
                    const isSetShowAddingConfirmationPopup = await this.getIsShowAddingConfirmationPopup(companyId);
                    this.setState({ isSetShowAddingConfirmationPopup });
                } catch (err) {
                    console.error(err);
                    this.setState({ isSetShowAddingConfirmationPopup: false });
                }
            } else {
                this.setState({ isSetShowAddingConfirmationPopup: false });
            }
        }
    };

    getCompanySelect = () => {
        this
            .ascAxios('post', `Common/companySelect`, {container: this.reactContainerPath})
            .then(result => {
                this.common_buttondisabledLengthCheck(`company_id`,`push`);
                this.setState({
                    companySelect: result.data
                });
            })
            .catch(err => {
                alert(this.getErrorString(err))
            });
    };
    /*
        音声ファイルの指定云々は構成不明のため
        バリデーションから外してます
            →構成解析後導入するか含め検討します
    */
    validationHandle = param => {
        let nowState = null;
        let {companyId,audioName,audioFile,voiceValidationFlag,confirmMemo,confirmValue} = this.state;
        switch(param){
            case "companyId":
            case "audioName":
                nowState = this.state[param]
                ? null
                : "error";
            break;
            case "confirmMemo":
                // 確認メモの文字数制限チェック（500文字以内）
                nowState = (!this.state[param] || this.state[param].length <= 500) ? null : 'error';

            break;
            case "confirmValue":
                nowState = confirmValue
                ? null
                : "error";
            break;
            case "insert":
                nowState = (companyId && audioName && audioFile != '');
                break;
            case "update":
                nowState = (companyId && audioName);
                break;
            case "delete":
                nowState = (companyId && audioName && voiceValidationFlag);
                break;
            default:
                nowState = null;
        }

        return nowState;
    };

    // 追加確認ポップアップ用のaudioURL生成
    getAudioURLForConfirm = () => {
        const { modalType, audioURL, audioFile } = this.state;
        
        // 新しい音声ファイルがアップロードされている場合は、ローカルファイルを優先
        // （新規登録時 または 編集時に新しいファイルをアップロード）
        if ((modalType === 'insert' || modalType === 'update') && audioFile && audioFile.length > 0) {
            try {
                return URL.createObjectURL(audioFile[0]);
            } catch (error) {
                console.error('ローカルファイルURL生成エラー:', error);
                return '';
            }
        }
        
        // 編集/削除時で新しいファイルがない場合は、既存のaudioURLを使用
        if ((modalType === 'update' || modalType === 'delete') && audioURL) {
            return audioURL;
        }
        
        return '';
    };

    render() {
        return (
            <div className="VoiceFile">
                <Row>
                    {
                        this.props.currentPermission.create
                        &&
                        <Col xs={12} md={12}>
                            <Button
                                id = "voiceFile-insert"
                                className = "table-button"
                                bsStyle = "default"
                                bsSize = "sm"
                                onClick = {this.modalShow("insert")}>
                                {this.props.langText.Body.InsertTitle}
                            </Button>

                        </Col>
                    }
                    <Col xs={12} md={12}>
                        <CommonTable
                            talbeRef={this.table}
                            style={{height: this.props.tableHeight}}
                            manual = "manual"
                            columns = {this.state.columns}
                            data = {this.state.data}
                            pages = {this.state.pages}
                            loading = {this.state.loading}
                            defaultSorted={[{id: "id", desc: true}]}
                            onFetchData = {this.fetchData}
                            filtered={this.state.filtered}
                            filterable = {true}
                            previousText = {this.props.langText.Table.PreviousText}
                            nextText = {this.props.langText.Table.NextText}
                            loadingText = {this.props.langText.Table.LoadingText}
                            noDataText = {this.props.langText.Table.NoDataText}
                            rowsText = {this.props.langText.Table.RowsText}/>
                    </Col>
                </Row>

                <VoiceFileModal
                    loginUserId = {this.props.userInfo.user_id}
                    state = {this.state}
                    propSetState = {this.propSetState}
                    langText = {this.props.langText}
                    charaLimit = {this.props.charaLimit}
                    onClick = {this.onClickHandle}
                    onTextChange_Limit = {this.onTextChange_Limit}
                    onSelectChange = {this.onSelectChange}
                    onMultiSelectChange = {this.onMultiSelectChange}
                    onCheckBoxChange = {this.onCheckBoxChange}
                    onRadioChange = {this.onRadioChange}
                    onFileChange = {this.onFileChange}
                    getScopeGreaterEqual = {this.getScopeGreaterEqual}
                    validationHandle = {this.validationHandle}
                    sprintf={this.sprintf}/>

                {/* 追加確認ポップアップ */}
                {

                    this.isTargetShowAddingConfirmationPopup &&
                    this.state.isSetShowAddingConfirmationPopup &&
                    <AscConfirm
                        key={`voicefile-confirm-${this.state.modalType}`} // modalTypeが変わったら強制再作成
                        state={
                            {
                                ...this.state,
                                show: this.state.showConfirm || false // showConfirmをshowに変換
                            }
                        }
                        propSetState={this.propSetState}
                        langText={this.props.langText}
                        charaLimit={this.props.charaLimit}
                        validationHandle={this.validationHandle}
                        onTextChange_Limit={this.onTextChange_Limit}
                        onClick={this.onClickHandle}
                        sprintf={this.sprintf}
                        confirmKey={this.props.langText.Body.AudioName}
                        confirmKeyItem={this.state.audioName}
                        audioURL={this.getAudioURLForConfirm()}
                        customBtn1Func={(e, value) => this.setState({
                            showConfirm: false,
                            confirmMemo: "",
                            confirmValue: ""
                        })}
                    />
                }
            </div>
        );
    }
}